import React from 'react';
import clsx from 'clsx';

import { Grid } from '@shared/components';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

import useStyles from './style';

const paperElevation = 1;
const noop = () => {};
const ExtensionGrid = ({
  gridData = [],
  pageSize = 20,
  pageNumber = 1,
  total = 10,
  onPageSizeChange = noop,
  onPageNumberChange = noop,
  onSyncConfirm = noop,
  isLoading = false,
  isSyncingRecords = false,
  sortObj = null,
  handleSortChange = noop,
}) => {
  const classes = useStyles();
  const columns = [
    {
      field: 'MailboxID',
      label: 'MAIL BOX ID',
      canSort: true,
      render: row => (
        <Tooltip title={row['MailboxID']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['MailboxID'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'SendWelcomeEmail',
      label: 'SEND WELCOME EMAIL',
      canSort: true,
      render: row => (
        <Tooltip title={String(row['SendWelcomeEmail'])} placement='top-start'>
          <Typography variant='body2' noWrap>
            {String(row['SendWelcomeEmail']) || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Status',
      label: 'STATUS',
      canSort: true,
      render: row => (
        <Tooltip title={row['Status']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['Status'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Extension',
      label: 'EXTENSION',
      canSort: true,
      render: row => (
        <Tooltip
          title={row['Extension'] ? row['Extension'] : ''}
          placement='top-start'
        >
          <Typography variant='body2' noWrap>
            {row['Extension'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'FirstName',
      label: 'FIRST NAME',
      canSort: true,
      render: row => (
        <Tooltip title={row['FirstName']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['FirstName'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'LastName',
      label: 'LAST NAME',
      canSort: true,
      render: row => (
        <Tooltip
          title={row['LastName'] ? row['LastName'] : ''}
          placement='top-start'
        >
          <Typography variant='body2' noWrap>
            {row['LastName'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Email',
      label: 'EMAIL',
      canSort: true,
      render: row => (
        <Tooltip title={row['Email'] ? row['Email'] : ''} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['Email'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'PhoneID',
      label: 'DEVICE ID',
      canSort: true,
      render: row => (
        <Tooltip title={row['PhoneID']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['PhoneID'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'DeviceName',
      label: 'DEVICE NAME',
      canSort: true,
      render: row => (
        <Tooltip title={row['DeviceName']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['DeviceName'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Model',
      label: 'DEVICE MODEL',
      canSort: true,
      render: row => (
        <Tooltip title={row['Model'] ? row['Model'] : ''} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['Model'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Password',
      label: 'PASSWORD',
      canSort: true,
      render: row => (
        <Tooltip title={row['Password']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['Password'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Pin',
      label: 'PIN',
      canSort: true,
      render: row => (
        <Tooltip title={row['Pin']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['Pin'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Timezone',
      label: 'TIMEZONE',
      canSort: true,
      render: row => (
        <Tooltip title={row['Timezone']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['Timezone'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Serial',
      label: 'SERIAL',
      canSort: true,
      render: row => (
        <Tooltip
          title={row['Serial'] ? row['Serial'] : ''}
          placement='top-start'
        >
          <Typography variant='body2' noWrap>
            {row['Serial'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Number',
      label: 'NUMBER',
      canSort: true,
      render: row => (
        <Tooltip title={row['Number']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['Number'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'CustomerName',
      label: 'CUSTOMER NAME',
      canSort: true,
      render: row => (
        <Tooltip title={row['CustomerName']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['CustomerName'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Site',
      label: 'SITE',
      canSort: true,
      render: row => (
        <Tooltip title={row['Site']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['Site'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Street',
      label: 'STREET',
      canSort: true,
      render: row => (
        <Tooltip title={row['Street']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['Street'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Street2',
      label: 'STREET2',
      canSort: true,
      render: row => (
        <Tooltip title={row['Street2']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['Street2'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'City',
      label: 'CITY',
      canSort: true,
      render: row => (
        <Tooltip title={row['City']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['City'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'State',
      label: 'STATE',
      canSort: true,
      render: row => (
        <Tooltip title={row['State']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['State'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'ZipCode',
      label: 'ZIPCODE',
      canSort: true,
      render: row => (
        <Tooltip title={row['ZipCode']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['ZipCode'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Country',
      label: 'COUNTRY',
      canSort: true,
      render: row => (
        <Tooltip title={row['Country']} placement='top-start'>
          <Typography variant='body2' noWrap>
            {row['Country'] || '-'}
          </Typography>
        </Tooltip>
      ),
    },
  ];

  return (
    <Paper
      className={clsx('mr-10 ml-10 p-6 mt-5 mb-5')}
      elevation={paperElevation}
    >
      <div className={'d-flex f-justify-between mb-3'}>
        <Typography variant='h6' className='bold-font mb-5'>
          Table Name
        </Typography>
        <div>
          <Button
            variant='contained'
            color='primary'
            className='bold-font'
            onClick={onSyncConfirm}
            disabled={isSyncingRecords || isLoading}
          >
            Sync Changes
          </Button>
        </div>
      </div>
      <Grid
        hasLoader
        isLoading={isLoading}
        pageSize={pageSize}
        pageNumber={pageNumber}
        total={total}
        columns={columns}
        data={gridData}
        hasSelection={false}
        onPageSizeChange={onPageSizeChange}
        onPageNumberChange={onPageNumberChange}
        showRowDivider
        classes={{
          container: classes.uploadWrapper,
        }}
        sortBy={columns.findIndex(column => column.field === sortObj?.field)}
        sortOrder={sortObj?.order}
        onSort={handleSortChange}
      />
    </Paper>
  );
};
export default ExtensionGrid;
